module.exports = __webpack_public_path__ + "media/packs/images/flags/FI-8802b916563175c5a5ad53e5293a9b3c.svg";